export type UserType = 'admin' | 'standard';
export const VercelIntendedPlatformName = 'VERCEL';

export interface Profile {
  _id: string;
  fullName: string;
  email: string;
  emailVerified: boolean;
  role: string;
  cloakedByAdmin: any;
}

export interface Account {
  _id: string;
  accountName: string;
  linkedToVercel: boolean;
  intendedPlatform: string | undefined;
  currentBillingPeriodEnd: number | undefined;
}

export interface Region {
  _id: string;
  name: string;
}

export interface Discount {
  name: string;
  end: number;
}

export interface Plan {
  _id: string;
  name: string;
  priceAmount: number;
  priceCurrency: string;
  socksProxy: boolean | undefined;
  httpProxy: boolean | undefined;
  requestsLimit: number;
  bandwidthLimit: number;
}

export interface BootstrapResponse {
  profile: Profile;
  account: Account;
  regions: Region[];
  plans: Plan[];
}

export interface ProxyApplicationListItem {
  _id: string;
  externalProxyUuid: string;
  name: string;
  plan: Plan;
  region: Region;
  vercelEnvironments: string[];
  status: string;
  vercelProjectExternalId?: string
}

export interface ProxyApplicationDetails {
  name: string;
  region: string;
  ips: string[];
  usage: {
    requests: number;
    bandwidth: number;
  },
  proxyType: 'http' | 'socks';
  proxyUrl: string;
  plan: Plan;
  vercelProjectExternalId?: string;
  vercelProjectFramework?: string;
}

export interface User {
  id: string,
  email: string,
  fullName: string,
  role: UserType
}

export interface VercelEnvironment {
  name: string;
  isAvailable: {
    http: boolean,
    socks: boolean
  }
}

export interface VercelProject {
  name: string;
  externalId: string;
  framework: string;
  environments: VercelEnvironment[];
}

export interface UsagePeriod {
  createdAt: string;
  usage: {
    requests: number;
    bandwidth: number;
  }
}